import { METRC_SSO_REDIRECT_STATE_STORAGE_KEY } from '../constants';
import type { MetrcImportWorkflow } from '../containers/Imports/ImportsWizardContext';
import type { SsoClientAuth } from '../types/index';

export type MetrcSsoRedirectState = {
  organizationId: number | string;
  marketId: number;
  market: string;
  ssoBaseUrl: string;
  ssoClientId: string;
  // Absent in states saved before RID-3173; treated as 'public'.
  ssoClientAuth?: SsoClientAuth;
  returnTo: string;
  workflow: MetrcImportWorkflow;
};

export function readMetrcSsoRedirectState(): MetrcSsoRedirectState | null {
  const raw = window.sessionStorage.getItem(METRC_SSO_REDIRECT_STATE_STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function writeMetrcSsoRedirectState(state: MetrcSsoRedirectState): void {
  window.sessionStorage.setItem(METRC_SSO_REDIRECT_STATE_STORAGE_KEY, JSON.stringify(state));
}

export function clearMetrcSsoRedirectState(): void {
  window.sessionStorage.removeItem(METRC_SSO_REDIRECT_STATE_STORAGE_KEY);
}
